import * as firebase from 'firebase'

export class FirebaseAuthentication {
    constructor() {

        if (!firebase.apps.length) {
            firebase.initializeApp(this.config)
        }
        this.googleProvider = new firebase.auth.GoogleAuthProvider()
        this.facebookProvider = new firebase.auth.FacebookAuthProvider()
        this.currentUser = firebase.auth().currentUser
        console.log("current user : ", this.currentUser)
        firebase.auth().onAuthStateChanged(user => {

            if (user) {
                this.currentUser = user
                this.isAuthenticated = true
            } else {
                this.isAuthenticated = false
            }
        })
    }
    // property 
    isAuthenticated = undefined;
    manuallyLogin
    googleToken
    facebookToken
    user
    currentUser
    /////
    config = {
        apiKey: "AIzaSyCaIxMarog1k6pHiID5LkSjFCYj3U3NNsQ",
        authDomain: "mcommerce-dashboard.firebaseapp.com",
        databaseURL: "https://mcommerce-dashboard.firebaseio.com",
        projectId: "mcommerce-dashboard",
        storageBucket: "mcommerce-dashboard.appspot.com",
        messagingSenderId: "501335675666"
    }
    get authenticated() {
        return new Promise((resolve, reject) => {
            if (this.isAuthenticated == undefined) {
                setTimeout(() => {
                    this.authenticated.then(resolve)
                }, 200)
            } else {
                console.log("is auth: ", this.isAuthenticated)
                resolve(this.isAuthenticated);
            }
        })
    }
    async getIdToken() {
        try {
            const idToken = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)
            console.log("Firebase id token:", idToken)
            return idToken
        } catch (error) {
            console.log("Get token error: ", error)
            return undefined
        }
    }
    async signInWithGoogle() {
        try {
            const result = await firebase.auth().signInWithPopup(this.googleProvider)
            this.googleToken = result.credential.accessToken
            this.user = result.user
            console.log(this.user)
            await this.getIdToken()
            return true
        } catch (error) {
            return false
        }

    }
    async signInWithFacebook() {
        const result = await firebase.auth().signInWithPopup(this.facebookProvider)
        this.googleToken = result.credential.accessToken
        this.user = result.user
        console.log(this.user)

    }
    async createUserByEmailAndPassword(email, password) {
        try {
            const result = await firebase.auth().createUserWithEmailAndPassword(email, password)
            return true
        } catch (error) {
            console.log(error)
            return false
        }

    }
    async signInWithEmailAndPassword(email, password) {
        try {
            const result = await firebase.auth().signInWithEmailAndPassword(email, password)
            this.isAuthenticated = true
            this.user = result.user
            //await this.getIdToken()
            return true
        } catch (error) {
            console.log(error)
            return false
        }
    }
    async signOut() {
        try {
            await firebase.auth().signOut()
            this.isAuthenticated = false
            console.log("Đăng xuất thành công")
            return true
        } catch (error) {
            console.log("Đăng xuất không thành công")
            return false
        }
    }
}


// WEBPACK FOOTER //
// ./src/authentication/firebase.js